import { render, staticRenderFns } from "./Tramite.vue?vue&type=template&id=2cc5786e&scoped=true"
import script from "./Tramite.vue?vue&type=script&lang=js"
export * from "./Tramite.vue?vue&type=script&lang=js"
import style0 from "./Tramite.vue?vue&type=style&index=0&id=2cc5786e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc5786e",
  null
  
)

export default component.exports